exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-table-expand label[data-v-09d6c70b]{width:90px}.el-dropdown-link[data-v-09d6c70b]{cursor:pointer;color:#1890ff;font-size:12px}.el-icon-arrow-down[data-v-09d6c70b]{font-size:12px}.icon-arrow-down[data-v-09d6c70b]  .el-dropdown-menu__item{font-size:12px}", ""]);

// exports
